/* eslint-disable max-len */
import { fireUtagEvent } from '@garmin/support-analytics';
import { mapState } from 'pinia';
import { useContentStore } from '../stores/content/index.js';
import { useProductStore } from '../stores/product/index.js';
import QueryToNameConverterMixin from './queryToNameConverter';
import {
  CONTENT_SOURCE_AUTHORED,
  queryParams,
} from '../config/results';

export default {
  name: 'ResultsMixin',
  mixins: [QueryToNameConverterMixin],
  computed: {
    ...mapState(useProductStore, ['productDetails']),
    ...mapState(useContentStore, [
      'topics',
      'subTopics',
      'getTopicsTransformed',
    ]),
  },
  methods: {
    onResultSelected(result, index) {
      if (result.contentSource === CONTENT_SOURCE_AUTHORED) {
        this.$router.push({
          name: 'faqView',
          query: {
            ...this.$route.query,
          },
          params: {
            faqId: result.contentId,
          },
        });

        const category = this.getEventCategory(this.$route.query);
        const action = this.getEventAction(this.$route.query);

        fireUtagEvent({
          event_action: action,
          event_category: category,
          event_label: result.title,
          event_value: index + 1,
          ps_topic: this.$route.query.issueTagName ? this.getFilterDisplayName(this.getTopicsTransformed(this.topics), this.$route.query.issueTagName) : '',
          ps_sub_topic: this.$route.query.issueSubTagName ? this.getFilterDisplayName(this.getTopicsTransformed(this.subTopics), this.$route.query.issueSubTagName) : '',
          product_name: this.productDetails?.displayName,
        });
      } else {
        window.open(result.url, '_blank');
        fireUtagEvent({
          event_action: 'Manual Topic',
          event_category: `${this.systemConfig.mode} - Search`,
          event_label: result.title,
        });
      }
    },
    onContentShowMore() {
      const textPage = this.$route.query.textPage ? Number(this.$route.query.textPage) + 1 : 1;
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          textPage,
        },
      });

      this.triggerShowMoreAnalytics();
    },
    onVideosShowMore() {
      const videoPage = this.$route.query.videoPage ? Number(this.$route.query.videoPage) + 1 : 1;
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          videoPage,
        },
      });

      this.triggerShowMoreAnalytics();
    },
    async fetchContentResultsPag({ to, tags = [], query = {} }) {
      let { issueTagName } = to.query;
      if (issueTagName && to.query.issueSubTagName) {
        issueTagName = null;
      }
      await this.fetchContentResults({
        mr: (((Number(to.query.textPage) || 0) + 1) * queryParams.content.mr),
        ...query,
        tags: [
          ...(issueTagName ? [issueTagName] : []),
          ...(to.query.issueSubTagName ? [to.query.issueSubTagName] : []),
          ...tags,
        ],
      });
    },

    async fetchVideoResultsPag({ to, tags = [], query = {} }) {
      let { issueTagName } = to.query;
      if (issueTagName && to.query.issueSubTagName) {
        issueTagName = null;
      }
      await this.fetchContentVideoResults({
        mr: ((Number(to.query.videoPage) || 0) + 1) * queryParams.video.mr,
        ...query,
        tags: [
          ...(issueTagName ? [issueTagName] : []),
          ...(to.query.issueSubTagName ? [to.query.issueSubTagName] : []),
          ...tags,
        ],
      });
    },

    triggerShowMoreAnalytics() {
      fireUtagEvent(`${this.systemConfig.mode} - Search,Link,Show More Results`);
    },

    getEventCategory(query) {
      if (query.issueTagName) {
        if (query.identifier) return `${this.systemConfig.mode} - Topic - Product`;
        return `${this.systemConfig.mode} - Topic`;
      }
      return `${this.systemConfig.mode} - Support Landing`;
    },

    getEventAction(query) {
      if (query.issueTagName) {
        return 'FAQ';
      }
      return 'Top Solutions - FAQ';
    },
  },
};
